export const types = {
    // Sync
    AUTHENTICATE: 'AUTHENTICATE',
    INITIALIZE:   'INITIALIZE',
    LOGOUT:       'LOGOUT',

    // Async
    SIGNUP_ASYNC:       'SIGNUP_ASYNC',
    LOGIN_ASYNC:        'LOGIN_ASYNC',
    AUTHENTICATE_ASYNC: 'AUTHENTICATE_ASYNC',
    INITIALIZE_ASYNC:   'INITIALIZE_ASYNC',
    LOGOUT_ASYNC:       'LOGOUT_ASYNC',
};
